export const TESTIMONIALS = [
  {
    name: "Marie-Claire Dubois", city: "Sault Ste. Marie, ON", service: "House Cleaning",
    text: "Same crew every two weeks for a year now. They know my house better than I do — and I've never once had to call about a missed spot.",
  },
  {
    name: "James Patterson", city: "Toronto, ON", service: "Commercial Cleaning",
    text: "We run three offices and switched after two bad contractors. The monthly audit reports alone are worth it — everything is measured and documented.",
  },
  {
    name: "Sarah Kowalchuk", city: "Winnipeg, MB", service: "Move-Out Cleaning",
    text: "Got my full damage deposit back. The time-stamped photos they send after the clean made the handover completely painless.",
  },
  {
    name: "Daniel Tremblay", city: "Québec, QC", service: "Deep Cleaning",
    text: "Après nos rénovations, la poussière était partout. L'équipe a tout repris en une journée — armoires, plinthes, vitres. Impeccable.",
  },
  {
    name: "Aisha Rahman", city: "Calgary, AB", service: "Airbnb Turnover",
    text: "My listing went from 4.6 to 4.9 stars in two months. Same-day flips, linens handled, photos before every check-in. It runs itself now.",
  },
  {
    name: "Michael O'Brien", city: "St. John's, NL", service: "Carpet Cleaning",
    text: "Two kids, one dog, Atlantic weather. The extraction pulled out stains I thought were permanent. Carpets look new.",
  },
  {
    name: "Priya Sharma", city: "Vancouver, BC", service: "Eco-Friendly Cleaning",
    text: "My daughter has asthma, so products matter to us. Fully fragrance-free, HEPA vacuums, and the clean is genuinely excellent.",
  },
  {
    name: "Robert MacLeod", city: "Halifax, NS", service: "Janitorial Services",
    text: "They took over our building mid-contract from a competitor. Night and day — the washrooms alone tell the story to every tenant.",
  },
  {
    name: "Emily Chen", city: "Ottawa, ON", service: "Window Cleaning",
    text: "Storefront glass twice a month, streak-free every time. Customers literally commented on it the first week. Worth every dollar.",
  },
];
